import { render, staticRenderFns } from "./Score_Rules.vue?vue&type=template&id=3402f36a&scoped=true"
import script from "./Score_Rules.vue?vue&type=script&lang=js"
export * from "./Score_Rules.vue?vue&type=script&lang=js"
import style0 from "./Score_Rules.vue?vue&type=style&index=0&id=3402f36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402f36a",
  null
  
)

export default component.exports